<template>
  <div>
    <b-sidebar
      id="sidebar-customer-List"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-customer-List-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div class="py-2" v-else>
          <div
            class="mx-2 d-flex justify-content-between align-items-center"
          >
            <label class="header-text">ค้นหาข้อมูลลูกค้า</label>
            <label
              class="pointer"
              @click="hide()"
              ><b-icon icon="x-circle-fill"></b-icon
            ></label>
          </div>
          <div class="p-2">
            <div class="d-flex">
              <b-input-group>
                <b-form-input
                  class="input-search"
                  placeholder="ค้นหา"
                  @keypress="handlePushMessage"
                  v-model="filter.search"
                ></b-form-input>
              </b-input-group>
              <b-button
                class="search-circle-bth"
                ><span class="icon-input m-auto pr-2">
                  <font-awesome-icon
                    icon="search"
                    title="View"
                    @click="searchUser('search')"
                  /> </span
              ></b-button>
            </div>
          </div>
          <div class="py-2 detail-panel">
            <div class="px-2 text-sub text-grey d-flex justify-content-between">
              <span>ชื่อ / สมาชิก / โทร</span>
              <span>ระดับ / คะแนนสะสม / วันที่สมัคร</span>
            </div>
            <div
              class="ml-2 mr-2 mt-2 py-2 px-2 customer-card"
              v-for="(c, index) in customerList"
              :key="index"
              @click="selectCustomer(c)"
            >
              <div class="d-flex justify-content-between">
                <p>
                  <label>{{ c.first_name_th }} {{ c.last_name_th }}</label>
                </p>
                <p>{{ c.member_tier }}</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>{{ c.member_id }}</p>
                <p>{{ c.point }} คะแนน</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>{{ c.telephone }}</p>
                <p>{{ new Date(c.created_time) | moment($formatDate) }}</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <b-pagination
            size="sm"
            limit="4"
            v-model="filter.page"
            :total-rows="rows"
            :per-page="5"
            class="m-md-0 page-item"
            align="center"
            @change="pagination"
          ></b-pagination>
        </div>
      </template>
    </b-sidebar>
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "SlideCustomerList",
  components: { OtherLoading, InputText, ModalLoading },
  props: {
    search: {
      type: Object,
      isRequired: true,
    },
    customerListObj: { isRequired: false },
  },
  data() {
    return {
      showSlide: false,
      rows: 0,
      customerSelect: "",
      customerList: [],
      isLoading: false,
    };
  },
  computed: {
    filter() {
      return this.search
    }
  },
  methods: {
    async show() {
      this.$nextTick(() => (this.customerList = this.customerListObj));
      // this.filter.search = this.search;
      this.showSlide = true;
      this.isLoading = true;
      // await this.searchUser("search");
      this.isLoading = false;
      // this.filter.search = "";
    },
    hide() {
      this.showSlide = false;
      this.filter.page = 1;
    },
    searchUser(type) {
      this.$refs.modalLoading.show();
      this.filter.page = type == "search" ? 1 : this.filter.page;
      this.customerList = [];
      let body = {
        search: this.filter.search,
        datetime: this.$moment().format("YYYY-MM-DD"),
        skip: (this.filter.page - 1) * 5,
        take: 5,
        branch_id: this.$cookies.get("branch_id"),
      };

      this.axios
        .post(`${this.$baseUrl}/customer/searchuser`, body)
        .then((data) => {
          if (data.result == 1) {
            this.customerList = data.detail;
            this.rows = data.total_count;
          }
          this.$refs.modalLoading.hide();
        });
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.searchUser("search");
      }
    },
    pagination(Page) {
      this.filter.page = Page;
      this.searchUser("pagination");
    },
    async selectCustomer(customer) {
      this.$emit("onChangehUser", customer.member_id, customer);
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-card {
  background-color: white;
  border-radius: 8px;
  p {
    padding: 0px;
  }
}
.customer-card:hover {
  background-color: #d1d1d1;
}
</style>
